import { Expose } from "class-transformer";
import { VehicleClaimSubstates } from "src/containers/vehicle-claims/constants/vehicle-claim-steps";
import { BaseModel } from "src/shared/models/base.model";
import { QuotationVehicleClaim } from "./quotation";
import { ReparationVehicleClaim } from "./reparation";

class VehicleClaim extends BaseModel {
    @Expose() claimNumber = "";
    @Expose() brandCar = "";
    @Expose() occurrenceDateHour = "";
    @Expose() coverageApprovalDateHour: string | null = null;
    @Expose() plateCar = "";
    @Expose() modelCar = "";
    @Expose() namePlaceCare = "";
    @Expose() subStateKey: VehicleClaimSubstates = VehicleClaimSubstates.NONE;
    @Expose() email: string | null = null;
    @Expose() quotation: QuotationVehicleClaim | null = null;
    @Expose() reparation: ReparationVehicleClaim | null = null;
}

export { VehicleClaim };
